module.exports = __webpack_public_path__ + "Mahesh-6e966dda.png";